import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Phone, MessageSquare, X } from 'lucide-react';

const PHONE = '+15052197816';
const PRETTY = '(505) 219-7816';
const SMS_BODY = "Hi A Quality Handyman — I'm interested in a quote. My name is ";

// Floating "Call or Text Now" button on every public page; opens the visitor's own phone/SMS app straight to the business line.
export const CallTextNow = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const hidden = /^\/(portal|customer|employee|admin|aqh-mgmt-7816|estimates|invoices?|pay|approve|track|heypaolo)(\/|$)/.test(location.pathname)
    || ['/estimate', '/seasonal-flyer', '/analytics'].includes(location.pathname);
  if (hidden) return null;
  const smsHref = `sms:${PHONE}${/iPhone|iPad|Mac/i.test(navigator.userAgent) ? '&' : '?'}body=${encodeURIComponent(SMS_BODY)}`;

  return (
    <div className="fixed right-4 bottom-20 md:bottom-6 z-[60] flex flex-col items-end gap-2" data-testid="call-text-now">
      {open && (
        <div className="flex flex-col gap-2 animate-in slide-in-from-bottom-2 fade-in duration-200">
          <a href={`tel:${PHONE}`} data-testid="call-now-link" className="inline-flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full bg-white text-slate-900 shadow-lg border border-slate-200 font-semibold text-sm hover:bg-slate-50">
            <span className="w-8 h-8 rounded-full bg-brand-blue/10 text-brand-blue inline-flex items-center justify-center"><Phone className="w-4 h-4" /></span>
            Call {PRETTY}
          </a>
          <a href={smsHref} data-testid="text-now-link" className="inline-flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full bg-white text-slate-900 shadow-lg border border-slate-200 font-semibold text-sm hover:bg-slate-50">
            <span className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 inline-flex items-center justify-center"><MessageSquare className="w-4 h-4" /></span>
            Text us now
          </a>
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-label={open ? 'Close call or text options' : 'Call or text now'}
        data-testid="call-text-now-btn"
        className="inline-flex items-center gap-2 px-4 py-3 rounded-full bg-gradient-to-r from-brand-blue to-brand-teal text-white font-bold text-sm shadow-xl hover:scale-105 active:scale-95 transition-transform"
      >
        {open ? <X className="w-5 h-5" /> : <><Phone className="w-5 h-5" /><span>Call or Text Now</span></>}
      </button>
    </div>
  );
};

export default CallTextNow;
